const freightZoneConstants = {
  validFreightZoneHeaders: {
    'Name*': 'name',
    'Pincodes*': 'pincodes',
  },
  exportAndRejectionHeaders: {
    'Name*': 'name',
    'Pincodes*': 'pincodes',
  },
};

const replaceFieldWithFreightZone = ['city', 'reference_id', 'state', 'pincode', 'region'];

module.exports = {
    freightZoneConstants,
    replaceFieldWithFreightZone,
};
